export const Pill = ({ children, accent = "bg-ivory", border = "border-sandBeige", testId }) => (
  <span
    className={`wit-pill ${accent} ${border} text-cocoa`}
    data-testid={testId}
  >
    {children}
  </span>
);

export default Pill;
